import {
  Box,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import {
  EXTERNAL_SERVICE_CODE,
  ExternalServiceCodeType,
} from "types/externalService";
import {
  ConsumablePart,
  getConsumablePartTypeDisplayLabel,
  getConsumablePartValueDisplayLabel,
} from "utils/robot/consumablePart";
import { hasWarningConsumablePart } from "lib/robot";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useResetModal } from "./useResetModal";
import { ResetConsumablePartsModal } from "./ResetConsumablePartsModal";
import EditIcon from "@mui/icons-material/Edit";
import { notify } from "lib/notify";

type Props = {
  consumableParts: ConsumablePart[];
  exSrvCode: ExternalServiceCodeType;
  robotName: string;
  robotId: string;
};

export const ConsumablePartsView = ({
  robotId,
  robotName,
  consumableParts,
  exSrvCode,
}: Props) => {
  const resetModal = useResetModal({ robotId, afterCallback: () => {
    notify("保存しました")
  } });
  return (
    <>
      <TableRow>
        <TableCell colSpan={2} sx={{ bgcolor: "#f9f9f9", py: 1 }}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <CleaningServicesIcon
                sx={{ fontSize: 20, color: "text.secondary" }}
              />
              <Typography
                variant="categoryLabel"
                sx={{ color: "text.secondary" }}
              >
                消耗品状態
              </Typography>
            </Stack>
            <Box>
              {canUseResetButton(exSrvCode) && (
                <IconButton size="small" onClick={resetModal.onOpen}>
                  <EditIcon sx={{ fontSize: 20 }} color="primary" />
                </IconButton>
              )}
            </Box>
          </Box>
        </TableCell>
      </TableRow>
      {consumableParts.map((p) => {
        const partType = p.type;

        const typeLabel = getConsumablePartTypeDisplayLabel(
          partType,
          exSrvCode
        );
        const valueLabel = getConsumablePartValueDisplayLabel(
          partType,
          p.usage,
          p.max,
          exSrvCode
        );
        const isWarning = hasWarningConsumablePart(p);
        return (
          <TableRow key={p.type}>
            <TableCell>{typeLabel}</TableCell>
            <TableCell
              sx={{
                color: (theme) =>
                  isWarning ? theme.palette.error.main : "inherit",
              }}
            >
              {isWarning && (
                <ReportProblemIcon
                  fontSize="small"
                  color="error"
                  style={{
                    marginRight: "0.25rem",
                    verticalAlign: "middle",
                  }}
                />
              )}
              {valueLabel}
            </TableCell>
          </TableRow>
        );
      })}
      {resetModal.open && (
        <ResetConsumablePartsModal
          robotName={robotName}
          open={resetModal.open}
          onClose={resetModal.onClose}
          onReset={resetModal.onReset}
          isResetting={resetModal.isLoading}
          exSrvCode={exSrvCode}
          parts={consumableParts}
        />
      )}
    </>
  );
};

// --------------------------------------------
// ローカル関数
// --------------------------------------------
const allowedResetButtonSrvs: string[] = [EXTERNAL_SERVICE_CODE.DREAME];

const canUseResetButton = (code: string) => {
  return allowedResetButtonSrvs.includes(code);
};
